//import { id } from 'date-fns/locale';
import { makeAutoObservable, runInAction } from 'mobx';
import agent from '../api/agent';
import { CCTMovimiento } from '../models/CCTMoviemientos';
import { toast } from 'react-toastify';
import Swal from "sweetalert2";
import { MovimientoFormValues } from '../models/CCTMovimientoCreate';
//import { CCTOperacion, CCTOperacionesFormValues } from '../models/CCTOperacion';
//import { store } from './store';

export default class CCTMovimientoStore {
    CCTMovimientoRegistry = new Map<any, CCTMovimiento>();
    

    selectedCCTMovimiento: CCTMovimiento | undefined = undefined;

    editMode = false;
    loading = false;
    loadingInitial = false;
    saldo_actual_total:string = ""

    constructor() {
        makeAutoObservable(this)
    }

    get CCTMovimientoByCodigo() {
        return Array.from(this.CCTMovimientoRegistry.values());
    }

    get groupedCCTMovimientos() {
        return this.CCTMovimientoRegistry
    }

    // loadCCTMovimientos = async () => {
    //     this.loadingInitial = true;
    //     try {
    //         const CCTMovimientos: CCTMovimiento[] = await agent.CCTMovimientos.list();
    //         CCTMovimientos.forEach(element => {
    //             this.setCCTMovimiento(element);
    //         })
    //         this.setLoadingInitial(false);
    //     } catch (error) {
    //         this.setLoadingInitial(false);
    //     }
    // }
    
    loadCCTMovimiento = async (idCliente: string, cuenta: string) => {
        let CCTMovimiento = this.getCCTMovimiento(idCliente);
        this.CCTMovimientoRegistry.clear()
        if (CCTMovimiento) {
            this.CCTMovimientoRegistry.clear()
            this.selectedCCTMovimiento = CCTMovimiento;
            return CCTMovimiento;
        } else {
            this.loadingInitial = true;
            try {
                this.CCTMovimientoRegistry.clear()
                const CCTMovimientos: CCTMovimiento[] =  await agent.CCTMovimientos.details(idCliente, cuenta);
                CCTMovimientos.forEach(element => {
                    this.setCCTMovimiento(element);
                })
                runInAction(() => {
                    this.selectedCCTMovimiento = CCTMovimiento || this.selectedCCTMovimiento;
                })
                this.setLoadingInitial(false);
                return CCTMovimiento;
            } catch (error) {
                this.setLoadingInitial(false);
            }
        }
    }

    private setCCTMovimiento = (data: CCTMovimiento) => {
        this.CCTMovimientoRegistry.set(data.id, data);
    }

    private getCCTMovimiento = (idCliente: any) => {
        return this.CCTMovimientoRegistry.get(idCliente);
    }

    deleteCCTMovimiento = async (userId: string, cuenta: string, codigoTipoTransaccion: number, numeroTransaccion: string) => {
                this.loading = true;
            try {
            await agent.CCTMovimientos.delete(userId, cuenta, codigoTipoTransaccion, numeroTransaccion).then((response) => {
                /*if ( response === "Se ha eliminado el movimiento del estudiante en el curso dado.") {
                toast.success("Se ha cancelado la inscripción del estudiante en el curso dado.");

                //this.InscriptionRegistry.delete(Inscription.id);
                } else {
                toast.error("Ocurrió un error al cancelar la inscripción.");
                }*/
            });
            runInAction(() => (this.loading = false));
        } catch (error) {
            runInAction(() => (this.loading = false));
        }
    }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }

    createCCTMovimiento = async (Movimiento: MovimientoFormValues) => {
        try {
            await agent.CCTMovimientos.create(Movimiento).then((response) => {
                if(response === "Se agregó el movimiento a la cuenta designada."){
                    toast.success("Se agregó el movimiento a la cuenta designada.");
                    Swal.close();
                }else if(response === "Error al crear datos del movimiento"){
                    toast.error("Ocurrió un error al enviar los datos del movimiento.");
                    Swal.close();
                }else if(response === "Ocurrio un error al enviar los datos del movimiento a la base de datos."){
                    toast.error("Ocurrió un error al crear el movimiento, se ingresó un duplicado.");
                }
            });
            runInAction(() => {
                this.loading = false;
            })
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }

    editCCTMovimiento = async (idCliente: string, cuenta: string, codigoTipoTransaccion: number, numeroTipoTransaccion: string, Movimiento: MovimientoFormValues) => {
        try {
            await agent.CCTMovimientos.edit(idCliente, cuenta, codigoTipoTransaccion, numeroTipoTransaccion, Movimiento).then((response) => {
                if(response === "Se agregó el movimiento a la cuenta designada."){
                    toast.success("Se agregó el movimiento a la cuenta designada.");
                    Swal.close();
                }else if(response === "Error al crear datos del movimiento"){
                    toast.error("Ocurrió un error al enviar los datos del movimiento.");
                    Swal.close();
                }else if(response === "Ocurrio un error al enviar los datos del movimiento a la base de datos."){
                    toast.error("Ocurrió un error al crear el movimiento, se ingresó un duplicado.");
                }
            });
            runInAction(() => {
                this.loading = false;
            })
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }

    // updateCCTMovimiento = async (CCTMovimiento: CCTMovimientoFormValues) => {
    //     try {
    //         await agent.CCTMovimientos.update(CCTMovimiento);
    //         runInAction(() => {
    //             if (CCTMovimiento.idCliente) {
    //                 let updateCCTMovimiento = {...this.getCCTMovimiento(CCTMovimiento.idCliente), ...CCTMovimiento}
    //                 this.CCTMovimientoRegistry.set(CCTMovimiento.idCliente, updateCCTMovimiento as CCTMovimiento);
    //                 this.selectedCCTMovimiento = updateCCTMovimiento as CCTMovimiento
    //                 this.loading = false;
    //             }
                   
    //         } )
    //     } catch (error) {
    //     }
    // }

    // deleteCCTMovimiento = async (idCliente: string) => {
    //     this.loading = true;
    //     try {
    //         await agent.CCTMovimientos.delete(idCliente);
    //         runInAction(() => {
    //             this.CCTMovimientoRegistry.delete(idCliente);
    //             this.loading = false;
    //         })
    //     } catch (error) {
    //         runInAction(() => {
    //             this.loading = false;
    //         })
    //     }
    // }
}